// A collection of animal emojis for user icons
const ANIMAL_ICONS = [
  '🐱', '🐶', '🐺', '🦊', '🐸', '🐙', '🦋', '🐝', '🐢', '🐨',
  '🐼', '🦁', '🐯', '🐮', '🐷', '🐭', '🐹', '🐰', '🦝', '🐻',
  '🐧', '🐦', '🦅', '🦆', '🦉', '🐓', '🦃', '🕊️', '🦚', '🦜',
  '🐒', '🦍', '🐘', '🦏', '🦛', '🐪', '🐫', '🦒', '🐄', '🐎',
  '🦄', '🐊', '🐍', '🦎', '🐲', '🐉', '🦕', '🦖', '🐳', '🐋',
  '🐬', '🦈', '🐟', '🐠', '🐡', '🦐', '🦀', '🐚', '🦞', '🕷️'
]

// Generate a consistent animal icon for a user based on their userId
export function getUserIcon(userId: string): string {
  // Use a simple hash function to get a consistent index
  let hash = 0
  for (let i = 0; i < userId.length; i++) {
    const char = userId.charCodeAt(i)
    hash = ((hash << 5) - hash) + char
    hash = hash & hash // Convert to 32-bit integer
  }
  
  // Get absolute value and mod by array length
  const index = Math.abs(hash) % ANIMAL_ICONS.length
  return ANIMAL_ICONS[index]
}

// Get a random animal icon (for preview purposes)
export function getRandomAnimalIcon(): string {
  const randomIndex = Math.floor(Math.random() * ANIMAL_ICONS.length)
  return ANIMAL_ICONS[randomIndex]
} 